import { StoreQueryType } from "@common/utils/use-query/types";
import { isChanging } from "@stores/instances/utils";
import { purchasesStore } from "@stores/purchases";
import { IPurchase } from "@stores/purchases/types";
import { useEffect, useState } from "react";

interface IUseReloadInstanceWhenChangingRes
  extends Pick<StoreQueryType, "error"> {
  timeElapsed: number;
  isInstanceChanging: boolean;
  purchase?: IPurchase;
}

export function useReloadInstanceWhenChanging(
  { id, hosted_instance }: IPurchase,
  reloadInterval = 5000,
): IUseReloadInstanceWhenChangingRes {
  // purchase
  const {
    error: purchaseError,
    data: purchase,
    refetch: refetchPurchase,
  } = purchasesStore.useGetPurchase(id);
  const instance = purchase?.hosted_instance || hosted_instance;

  // FIX
  // See https://metaboat.slack.com/archives/C07RMUQ0GE5/p1749129991166229?thread_ts=1749108815.471439&cid=C07RMUQ0GE5
  // In the FE, when we are reloading a single purchase, once the request succeed, we reload right after all purchases in the background
  // Sometimes (only), the status of the single purchase.hosted_instance will not be in sync with the status of that same instance in the purchases list
  // It can be replicated when changing the DNS alias of an instance
  const { error: purchasesError, data: purchases } =
    purchasesStore.useGetPurchases();
  const purchaseFromList = purchases?.find((purchase) => purchase.id === id);
  const instanceFromList = purchaseFromList?.hosted_instance;

  // changing?
  const [count, setCount] = useState(0);
  const arePurchasesEqual =
    instanceFromList && instance
      ? instanceFromList.status === instance.status &&
        instanceFromList.health === instance.health &&
        instanceFromList.migration_status === instance.migration_status
      : true;
  const isInstanceChanging =
    !arePurchasesEqual || (instance ? isChanging(instance) : false);

  useEffect(() => {
    let interval;
    if (isInstanceChanging) {
      interval = setInterval(() => {
        refetchPurchase();
        setCount(count + 1);
      }, reloadInterval);
    }

    return () => clearInterval(interval);
  }, [isInstanceChanging, count, refetchPurchase, reloadInterval]);

  return {
    timeElapsed: count * reloadInterval,
    error: purchaseError || purchasesError,
    isInstanceChanging,
    purchase,
  };
}
